// Avoid `console` errors in browsers that lack a console.
(function() {
  const noop = function() {};
  const methods = [
    'assert',
    'clear',
    'count',
    'debug',
    'dir',
    'dirxml',
    'error',
    'exception',
    'group',
    'groupCollapsed',
    'groupEnd',
    'info',
    'log',
    'markTimeline',
    'profile',
    'profileEnd',
    'table',
    'time',
    'timeEnd',
    'timeline',
    'timelineEnd',
    'timeStamp',
    'trace',
    'warn'
  ];
  const console = window.console || {};

  for (const method of methods) {
    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
})();

if (typeof jQuery === 'undefined') {
  console.warn("jQuery hasn't loaded");
} else {
  console.log(`jQuery ${jQuery.fn.jquery} has loaded`);
  const $ = jQuery; // eslint-disable-line no-undef, no-unused-vars
}

// Place any jQuery/helper plugins in here.

/**
 *  dynamically updates two global properties of the window object: devType and devWidth, based on the current width of the document body.
 */
function setWindowSizeProperties() {
  const bodyWidth = document.body.clientWidth;
  window.devWidth = bodyWidth;

  if (bodyWidth <= 575) {
    console.log('mobile: ' + bodyWidth + 'px');
    window.devType = "mobile";
  } else if ((bodyWidth >= 576) && (bodyWidth <= 767)) {
    console.log('xs: ' + bodyWidth + 'px');
    window.devType = "xs";
  } else if ((bodyWidth >= 768) && (bodyWidth <= 991)) {
    console.log('sm/tablet: ' + bodyWidth + 'px');
    window.devType = "sm";
  } else if ((bodyWidth >= 992) && (bodyWidth + 15 <= 1199)) {
    console.log('md: ' + bodyWidth + 'px');
    window.devType = "md";
  } else if ((bodyWidth + 15 >= 1200) && (bodyWidth + 15 <= 1599)) {
    console.log('lg: ' + bodyWidth + 'px');
    window.devType = "lg";
  } else if (bodyWidth + 15 > 1599) {
    console.log('xlg: ' + bodyWidth + 'px');
    window.devType = "xlg";
  }
}
// Call the function to set the properties on page load
setWindowSizeProperties();
// Set up an event handler for resizing the window
window.addEventListener('resize', setWindowSizeProperties);

document.addEventListener('DOMContentLoaded', function() {
  // Place your code that needs to run after the document has finished loading
});
jQuery(document).ready(function() {
  const $ = jQuery
  // ///////////////////////////////
  // Filter Players List Page
  // function filterPlayersByGenderCountryAndBrand() {
  //   const selectedGender = jQuery('#sorting-gender').val();
  //   const selectedCountry = jQuery('#sorting-countries').val();
  //   const selectedBrand = jQuery('#sorting-brands').val();
  //   jQuery('.player-list__table-body .player-list__table-row').each(function() {
  //     const rowGender = jQuery(this).attr('data-gender');
  //     const rowCountry = jQuery(this).attr('data-country');
  //     const rowBrand = jQuery(this).attr('data-brand');
  //
  //     if ((selectedGender === 'all' || rowGender === selectedGender) &&
  //       (selectedCountry === 'all' || rowCountry === selectedCountry) &&
  //       (selectedBrand === 'all' || rowBrand === selectedBrand)) {
  //       jQuery(this).css('display', 'flex');
  //     } else {
  //       jQuery(this).css('display', 'none');
  //     }
  //   });
  // }

  // ///////////////////////////////
  // Change Title on Players Lists Page When Gender Filter Changed
  // jQuery('#sorting-gender').on('change', function() {
  //   const selectedOption = jQuery('#sorting-gender').val();
  //   jQuery('.page-header .page-title').text(selectedOption === 'all' ? 'All Players' : selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1) + ' Players');
  // });

  // jQuery(window).on('load', function() {
  //   const genderSelect = jQuery('#sorting-gender');
  //   const pageTitle = jQuery('.page-header .page-title');
  //
  //   if (genderSelect.length && pageTitle.length) {
  //     const selectedOption = genderSelect.val();
  //     pageTitle.text(selectedOption === 'all' ? 'All Players' : selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1) + ' Players');
  //   }
  // });

  // jQuery('#sorting-gender, #sorting-countries, #sorting-brands').on('change', filterPlayersByGenderCountryAndBrand);
  // jQuery(window).on('load', filterPlayersByGenderCountryAndBrand);

  // Checking for the presence of the "page-template-template-player-list" class in the body of the document
  // Check if the current page is the player list template
  if ($('body').hasClass('page-template-template-player-list')) {
    // Function to construct a URL with selected select values
    function constructUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const gender = $('#sorting-gender').val() || 'all';
      const country = $('#sorting-countries').val() || 'all';
      const brand = $('#sorting-brands').val() || 'all';

      let baseUrl = window.location.href.split('?')[0]; // Get base URL
      baseUrl = baseUrl.replace(/\/page\/\d+/, ''); // Remove "/page/" followed by digits

      return `${baseUrl}?gender=${gender}&country=${country}&brand=${brand}`;
    }

    // Function to redirect to a constructed URL
    function redirectToUrl() {
      window.location.href = constructUrl();
    }

    // Form submission processing
    $('.player-list-selector').change(redirectToUrl);

    // Checking the URL on page load and setting select values
    const urlParams = new URLSearchParams(window.location.search);
    const gender = urlParams.get('gender') || 'all';
    $('#sorting-gender').val(gender);

    // Change page title based on gender
    const pageTitle = gender.charAt(0).toUpperCase() + gender.slice(1) + ' Players';
    $('.page-title').text(pageTitle);

    // Set select values from URL parameters
    $('#sorting-countries').val(urlParams.get('country') || 'all');
    $('#sorting-brands').val(urlParams.get('brand') || 'all');
  }

  // ///////////////////////////////
  // Search on Player List Page
  // Hiding results when clicking on a page outside of input
  jQuery(document).on('click', function(e) {
    // Close Single Search
    if (!jQuery(e.target).closest('.players-list-search, #players-list-search__result').length) {
      // jQuery('#players-list-search__result').hide();
      jQuery('.players-list-sorting').removeClass('players-list-sorting__active');
    }
    // Close Head-To-Head Search
    if (!jQuery(e.target).closest('.h2h-item-search--left, .h2h-item-result--left').length) {
      jQuery('.h2h-item-result--left').hide();
    }
    if (!jQuery(e.target).closest('.h2h-item-search--right, .h2h-item-result--right').length) {
      jQuery('.h2h-item-result--right').hide();
    }
  });

  // ///////////////////////////////
  // Single Player Table Collapse
  jQuery('.spst-row--title').on('click', function() {
    const rowFor = jQuery(this).data('rowFor');
    const dataRows = jQuery('.spst-row--data[data-row-id="' + rowFor + '"]');
    // Add or remove activity classes for data items
    dataRows.toggleClass('spst-row--data__active');
    // Add or remove an activity class for a header container
    jQuery(this).toggleClass('spst-row--title__active');
    const icon = jQuery(this).find('.spst-rh--icon');
    icon.toggleClass('spst-rh--icon__open spst-rh--icon__close');
  });

  // ///////////////////////////////
  // Mobile Navigation
  // Check the width of the screen when loading the page
  if (jQuery(window).width() >= 320 && jQuery(window).width() <= 575) {
    // Add classes when clicking on the "#menu-header" element
    jQuery('#menu-header').click(function() {
      jQuery('.modal-window--navigation').addClass('modal-window--navigation__active');
      jQuery('body').addClass('modal--opened');
    });

    // Delete classes when clicking on the ".modal-window--close" element
    jQuery('.modal-window--close').click(function() {
      jQuery('.modal-window--navigation').removeClass('modal-window--navigation__active');
      jQuery('body').removeClass('modal--opened');
    });
  }

  // ///////////////////////////////
  // Statistics Page
  // Statistics Page Selector Redirect
  if ($('body').hasClass('page-template-template-statistics') || $('body').hasClass('page-template-template-statistics-w')) {
    $('#sorting-gender').change(function() {
      const selectedGender = $(this).val();
      if (selectedGender === 'male') {
        window.location.href = '/statistics?g=male';
      } else if (selectedGender === 'female') {
        window.location.href = '/statistics?g=female';
      }
    });

    const urlParams = new URLSearchParams(window.location.search);
    const genderParam = urlParams.get('g');
    if (genderParam === 'female') {
      $('#sorting-gender').val('female');
    } else {
      $('#sorting-gender').val('male');
    }
  }

  // ///////////////////////////////
  // Single Player Radar
  if ( $( '#playerChart' ).length && (
    typeof ApexCharts !== 'undefined'
  ) )
  {
    // Checking if the ".single-player-info" element exists
    const $elPlayerInfo = $( '.single-player-info' );
    const $elRadar      = $( '.spi--radar' );

    const bodyWidth = $( 'body' ).width();

    let radarXaxisFontSize = '14px'; // Radar Labels Font Size

    function roundNearestLowTen(value) {
      return Math.ceil((value - 10) / 10 ) * 10
    }

    const elRadarWidth = $elRadar.width() ? roundNearestLowTen($elRadar.width()) : 700;
    // console.log('elRadarWidth: ', elRadarWidth)
    const elRadarHeight = $elRadar.height() ? roundNearestLowTen($elRadar.height() - 100) : 500; // -100 added to reduce height
    // console.log('elRadarHeight: ', elRadarHeight)
    const elRadarSmallest = elRadarWidth <= elRadarHeight ? elRadarWidth : elRadarHeight;
    // console.log('elRadarSmallest: ', elRadarSmallest)

    let chartWidth = elRadarWidth; // 700
    let chartHeight = elRadarHeight; // 500
    let radarSize = elRadarSmallest / 2.5; // 200

    if (bodyWidth <= 400) {
      radarXaxisFontSize = '10px'; // Update Radar Labels Font Size

      chartHeight = chartHeight - 250;
      chartWidth = chartWidth - 40;
      radarSize = radarSize - 30;

    } else if ((bodyWidth >= 401) && (bodyWidth <= 575)) {

      chartHeight = chartHeight - 100;
      chartWidth = chartWidth - 40;
      radarSize = radarSize - 30;

    } else if ((bodyWidth >= 576) && (bodyWidth <= 767)) {
      radarXaxisFontSize = '10px'; // Update Radar Labels Font Size
    } else if ((bodyWidth >= 768) && (bodyWidth <= 991)) {
    } else if ((bodyWidth >= 992) && (bodyWidth + 15 <= 1199)) {
    } else if ((bodyWidth + 15 >= 1200) && (bodyWidth + 15 <= 1599)) {
    } else if (bodyWidth + 15 > 1599) { }

    // console.log('chartWidth: ', chartWidth)
    // console.log('chartHeight: ', chartHeight)
    // console.log('radarSize: ', radarSize)

    if ($elPlayerInfo.length) {
      // Get attribute values for each parameter
      const general = parseInt($elPlayerInfo.attr('data-general')) || 0;
      const attack = parseInt($elPlayerInfo.attr('data-attack')) || 0;
      const serve = parseInt($elPlayerInfo.attr('data-serve')) || 0;
      const playerReturn = parseInt($elPlayerInfo.attr('data-return')) || 0;
      const aggressiveness = parseInt($elPlayerInfo.attr('data-aggressiveness')) || 0;
      const mental = parseInt($elPlayerInfo.attr('data-mental')) || 0;
      const consistency = parseInt($elPlayerInfo.attr('data-consistency')) || 0;

      // Replace the data values with those obtained from the attributes
      const options = {
        series: [{
          name: $elPlayerInfo.attr('data-title'),
          data: [general, attack, serve, playerReturn, aggressiveness, mental, consistency],
        }],
        chart: {
          height: chartHeight, // 500
          width: chartWidth, // 700
          type: "radar",
          toolbar: {
            show: false
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 500,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["#57D7D8"],
          dashArray: 0
        },
        fill: { opacity: 0.6, colors: ["#57D7D8"] },
        plotOptions: {
          radar: {
            size: radarSize, // 200
            polygons: {
              strokeColors: '#a8a8a8', // Web Color
              strokeWidth: 1, // Web Weight
              fill: {
                colors: ["transparent", "transparent"]
              }
            }
          }
        },
        markers: {
          size: 2,
          colors: ["#57D7D8"],
          strokeColors: ["#57D7D8"],
          strokeWidth: 2
        },
        xaxis: {
          categories: ['GENERAL', 'ATTACK', 'SERVE', 'RETURN', 'AGGRESSIVENESS', 'MENTAL', 'CONSISTENCY'],
          labels: {
            show: true,
            style: {
              colors: ['#151515', '#151515', '#151515', '#151515', '#151515', '#151515', '#151515'], // Label Font Color
              fontSize: radarXaxisFontSize, // 14px || 16px
              fontWeight: '400',
              fontFamily: '"Bebas Neue", sans-serif',
            }
          },
        },
        yaxis: {
          show: false,
        },
        noData: {
          text: 'Loading...'
        }
      };

      // Display the graph
      const chart = new ApexCharts(document.getElementById('playerChart'), options);
      chart.render();

      // Set Single Player Page Header Background Height Size
      // const bodyWidth = $('body').width();
      // console.log('bodyWidth', bodyWidth)
      // console.log('bodyWidth + 15', bodyWidth + 15)

      const $elSinglePlayerInfo = $('.single-player-info')
      const $elSinglePlayerStatsTitle = $('.single-player-stats--title')
      const $elPlayerSingleBg = $('.player-single-background')

      let singlePlayerBgHeight = 1080; // default height
      if (bodyWidth <= 575) {
        // console.log('mobile: ' + bodyWidth + 'px')
        singlePlayerBgHeight = $elSinglePlayerStatsTitle.position().top + parseInt($elSinglePlayerInfo.css("marginBottom")) * 4; // 70
      } else if ((bodyWidth >= 576) && (bodyWidth <= 767)) {
        // console.log('xs: ' + bodyWidth + 'px')
        singlePlayerBgHeight = $elSinglePlayerStatsTitle.position().top + parseInt($elSinglePlayerInfo.css("marginBottom")) * 7; // 180
      } else if ((bodyWidth >= 768) && (bodyWidth <= 991)) {
        // console.log('sm/tablet: ' + bodyWidth + 'px')
        singlePlayerBgHeight = $elSinglePlayerStatsTitle.position().top;
      } else if ((bodyWidth >= 992) && (bodyWidth + 15 <= 1199)) {
        // console.log('md: ' + bodyWidth + 'px')
        singlePlayerBgHeight = $elSinglePlayerStatsTitle.position().top + parseInt($elSinglePlayerInfo.css("marginBottom"));
      } else if ((bodyWidth + 15 >= 1200) && (bodyWidth + 15 <= 1599)) {
        // console.log('lg: ' + bodyWidth + 'px')
        singlePlayerBgHeight = $elSinglePlayerStatsTitle.position().top + parseInt($elSinglePlayerInfo.css("marginBottom")) / 4;
      } else if (bodyWidth + 15 > 1599) {
        // console.log('xlg: ' + bodyWidth + 'px')
        singlePlayerBgHeight = $elSinglePlayerStatsTitle.position().top + parseInt($elSinglePlayerInfo.css("marginBottom")) / 8;
      }

      $elPlayerSingleBg.height(singlePlayerBgHeight);

    }
  }

  // ///////////////////////////////
  // Head To Head Radar Init
  function initHeadToHeadRadar () {
    if ($('#h2hChart').length && (typeof ApexCharts !== 'undefined')) {

      const bodyWidth = $('body').width();

      const $elItemLeft = $('.h2h-item--left');
      const $elItemRight = $('.h2h-item--right');

      const $elRadarContainer = $('.h2h-item--middle');

      const elRadarWidth = $elRadarContainer.width() ? Math.ceil(($elRadarContainer.width() - 10) / 10 ) * 10 : 500;
      // const elRadarHeight = $elRadarContainer.height() ? Math.ceil(($elRadarContainer.height() - 10) / 10 ) * 10 - 100 : 500; // -100 added to reduce height
      const elRadarHeight = $elRadarContainer.height() ? Math.ceil(($elRadarContainer.height() - 10) / 10 ) * 10 : 500; //
      const elRadarSmallest = elRadarWidth <= elRadarHeight ? elRadarWidth : elRadarHeight;

      // console.log('$elRadarContainer.width()', $elRadarContainer.width())
      // console.log('elRadarWidth', elRadarWidth)
      // console.log('$elRadarContainer.height()', $elRadarContainer.height())
      // console.log('elRadarHeight', elRadarHeight)

      const chartWidth = elRadarWidth; // 500
      const chartHeight = elRadarHeight; // 500

      let radarSize = elRadarSmallest / 2.9; // 150
      if ((bodyWidth > 1200) && (bodyWidth < 1600)) {
        // radarSize = elRadarSmallest / 3.5; // 150
        radarSize = elRadarSmallest / 4; // 150
      }

      const leftPlayerData = {
        name: $('.h2h-item--left .h2h-item--name').text().trim(),
        data: [
          parseFloat($elItemLeft.attr('data-general')) || 0,
          parseFloat($elItemLeft.attr('data-attack')) || 0,
          parseFloat($elItemLeft.attr('data-serve')) || 0,
          parseFloat($elItemLeft.attr('data-return')) || 0,
          parseFloat($elItemLeft.attr('data-aggressiveness')) || 0,
          parseFloat($elItemLeft.attr('data-mental')) || 0,
          parseFloat($elItemLeft.attr('data-consistency')) || 0,
        ],
      };

      const rightPlayerData = {
        name: $('.h2h-item--right .h2h-item--name').text().trim(),
        data: [
          parseFloat($elItemRight.attr('data-general')) || 0,
          parseFloat($elItemRight.attr('data-attack')) || 0,
          parseFloat($elItemRight.attr('data-serve')) || 0,
          parseFloat($elItemRight.attr('data-return')) || 0,
          parseFloat($elItemRight.attr('data-aggressiveness')) || 0,
          parseFloat($elItemRight.attr('data-mental')) || 0,
          parseFloat($elItemRight.attr('data-consistency')) || 0,
        ],
      };

      const options = {
        series: [leftPlayerData, rightPlayerData],
        chart: {
          height: chartHeight, // 500
          width: chartWidth, // 500
          type: "radar",
          toolbar: { show: false },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: { enabled: true, delay: 150 },
            dynamicAnimation: { enabled: true, speed: 350 }
          },
        },
        stroke: {
          show: true,
          width: 2,
          // colors: ["#57D7D8", "#5A23FF"],
          colors: ["#939edd", "#371f7f"],
          dashArray: 0
        },
        // fill: { opacity: 0.6, colors: ["#57D7D8", "#5A23FF"] },
        fill: { opacity: 0.4, colors: ["#939edd", "#371f7f"] },
        plotOptions: {
          radar: {
            size: radarSize, // 150
            polygons: {
              strokeColors: '#a8a8a8',
              strokeWidth: 1,
              fill: { colors: ["transparent", "transparent"] }
            }
          }
        },
        markers: {
          size: 3,
          // colors: ["#57D7D8", "#5A23FF"],
          colors: ["#939edd", "#371f7f"],
          // strokeColors: ["#57D7D8", "#5A23FF"],
          strokeColors: ["#939edd", "#371f7f"],
          strokeWidth: 0 // 1
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'bottom',
          horizontalAlign: 'center',
          floating: false,
          fontSize: '24px',
          fontWeight: '400',
          fontFamily: '"Bebas Neue", sans-serif',
          formatter: undefined,
          inverseOrder: false,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          customLegendItems: [],
          offsetX: 0,
          offsetY: 0,
          labels: {
            colors: undefined,
            useSeriesColors: false
          },
          markers: {
            width: 24,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: ["#939edd", "#371f7f"],
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: -2,
          },
          itemMargin: {
            horizontal: 5,
            vertical: 0
          },
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: true
          },
        },
        xaxis: {
          categories: ['GENERAL', 'ATTACK', 'SERVE', 'RETURN', 'AGGRESSIVENESS', 'MENTAL', 'CONSISTENCY'],
          labels: {
            show: true,
            style: {
              colors: ['#151515', '#151515', '#151515', '#151515', '#151515', '#151515', '#151515'],
              fontSize: '14px', // 16px
              fontWeight: '400',
              fontFamily: '"Bebas Neue", sans-serif',
            }
          },
        },
        yaxis: { show: false },
        noData: { text: 'Loading...' }
      };
      // f88341
      const chart = new ApexCharts(document.getElementById("h2hChart"), options);
      chart.render();
    }
  }

  initHeadToHeadRadar();

  function recreateChart() {
    if ($('#h2hChart').length && (typeof ApexCharts !== 'undefined')) {
      $('.h2h-item--middle #h2hChart').remove();
      const chartElement = $('<div id="h2hChart"></div>');
      $('.h2h-item--middle').append(chartElement);
    }
  }

  // ///////////////////////////////
  // Head-To-Head Page
  function setH2HItemValues(side, element) {
    const $h2hItem = $(`.h2h-item--${side}`);

    const data = {
      general: $(element).attr('data-general'),
      attack: $(element).attr('data-attack'),
      consistency: $(element).attr('data-consistency'),
      aggressiveness: $(element).attr('data-aggressiveness'),
      serve: $(element).attr('data-serve'),
      return_: $(element).attr('data-return'),
      mental: $(element).attr('data-mental'),
      name: $(element).text(),
      country: $(element).attr('data-country'),
      flag: $(element).attr('data-flag')
    };

    $h2hItem.attr({
      'data-general': data.general || '0',
      'data-attack': data.attack || '0',
      'data-consistency': data.consistency || '0',
      'data-aggressiveness': data.aggressiveness || '0',
      'data-serve': data.serve || '0',
      'data-return': data.return_ || '0',
      'data-mental': data.mental || '0'
    });
    $h2hItem.find('.h2h-item--name').text(data.name.trim());
    $h2hItem.find('.h2h-item--country').text(data.country);
    $h2hItem.find('.h2h-item--flag')
      .attr('src', data.flag)
      .attr('alt', data.country)
      .attr('title', data.country);

    const randomRank = Math.floor(Math.random() * 9) + 1;
    $h2hItem.find('.h2h-item--rank').text(randomRank.toString().padStart(2, '0')); // ToDo: Temp Rank Item
  }
  // Head-To-Head Left Side
  $(document).on('click', '.h2h-item-result--left li', function(event) {
    setH2HItemValues('left', event.target);

    $('.h2h-item-search--left').val('');
    $('.h2h-item-result--left').hide();

    recreateChart();
    initHeadToHeadRadar();
  });
  // Head-To-Head Right Side
  $(document).on('click', '.h2h-item-result--right li', function(event) {
    setH2HItemValues('right', event.target);

    $('.h2h-item-search--right').val('');
    $('.h2h-item-result--right').hide();

    recreateChart();
    initHeadToHeadRadar();
  });

  // ///////////////////////////////
  // Pair Head-To-Head Rankings Page
  /**
   * Update player details when an item in the list is clicked.
   * @param {string} pairSelector - The selector for the pair container.
   */
  function updatePlayerDetails(pairSelector) {
    // Event delegation to handle click events for dynamically added list items
    $(document).on('click', pairSelector + ' li', function(){
      // Get the parent container of the pair
      const $parent = $(this).parent().parent();

      // Retrieve data attributes for the first player
      const playerId = $(this).data('player-first');
      const firstTitle = $(this).data('first-title');
      const firstCountry = $(this).data('country');
      const firstFlag = $(this).data('flag');

      // Retrieve data attributes for the second player
      const pairedId = $(this).data('player-paired');
      const pairedTitle = $(this).data('paired-title');
      const pairedCountry = $(this).data('country-second');
      const pairedFlag = $(this).data('flag-second');

      // Update HTML elements with player details
      $parent.find('.h2hip--player-first a').attr('href', '/post?p=' + playerId);
      $parent.find('.h2hip--player-first a').text(firstTitle);
      $parent.find('.h2hip--player-first img').attr('src', firstFlag);
      $parent.find('.h2hip--player-first .country').text(firstCountry);

      $parent.find('.h2hip--player-second a').attr('href', '/post?p=' + pairedId);
      $parent.find('.h2hip--player-second a').text(pairedTitle);
      $parent.find('.h2hip--player-second img').attr('src', pairedFlag);
      $parent.find('.h2hip--player-second .country').text(pairedCountry);
    });
  }

  // Initialize for Pair Head-To-Head Rankings Left
  updatePlayerDetails('.h2h-item-result--left');

  // Initialize for Pair Head-To-Head Rankings Right
  updatePlayerDetails('.h2h-item-result--right');


  // Disabled! Changed the flow
  // $(".rt-head").click(function() {
  //   // Add the class "rt-row__active" to the parent element ".rt-row"
  //   $(".rt-row").removeClass("rt-row__inactive");
  //   // $(".rt-row").removeClass("rt-row__active");
  //   // $(".rt-row").not($(this).closest(".rt-row")).removeClass("rt-row__active");
  //
  //   if ($(this).closest(".rt-row").hasClass("rt-row__active")) {
  //     $(this).closest(".rt-row").removeClass("rt-row__active");
  //     // We add the "rt-row__inactive" class to all ".rt-row" elements, except for the parent one
  //     $(".rt-row").not($(this).closest(".rt-row")).removeClass("rt-row__inactive");
  //   } else {
  //     $(this).closest(".rt-row").addClass("rt-row__active");
  //     // We add the "rt-row__inactive" class to all ".rt-row" elements, except for the parent one
  //     $(".rt-row").not($(this).closest(".rt-row")).addClass("rt-row__inactive");
  //   }
  // });
  // Disabled! Changed the flow

  // ///////////////////////////////
  // Home Header Slider
  if ($('body').hasClass('page-template-front-page')) {
    // ToDo: move loader from WP Console
    let sliderArray = [
      {title : "Top 5 Best Out-of-Court Plays Season 2023", link: "#", date: "12.03.2024", thumb: "/wp-content/themes/wp-padel/img/content/home-header-next.png", image: "/wp-content/themes/wp-padel/img/content/home-header.png"},
      {title : "Top 10 Unforgettable Moments of 2023", link: "#", date: "13.03.2024", thumb: "/wp-content/themes/wp-padel/img/content/home-header-next-2.png", image: "/wp-content/themes/wp-padel/img/content/home-header-2.png"},
      {title : "The Most Exciting Matches of 2023", link: "#", date: "14.03.2024", thumb: "/wp-content/themes/wp-padel/img/content/home-header-next-3.png", image: "/wp-content/themes/wp-padel/img/content/home-header-3.png"}
    ]; // ToDo: Move to AJAX

    let currentIndex = 0;

    function updateContent() {
      let currentObject = sliderArray[currentIndex];
      let nextObject = sliderArray[(currentIndex + 1) % sliderArray.length];

      $(".player-single-background").fadeOut(5, function() {
        $(this).css({
          "background-image": 'url(' + currentObject.image + ')'
        }).fadeIn(5);
      });

      $(".hh--title").fadeOut(500, function() {
        $(this).text(currentObject.title).fadeIn(500);
      });

      $(".hh--more").attr("href", currentObject.link);

      $(".hhf--next-img").fadeOut(500, function() {
        $(this).attr("src", nextObject.thumb).fadeIn(500);
      });

      $(".hhf--next-date").text(nextObject.date);
      $(".hhf--next-title").text(nextObject.title);

      $(".hhf--next-timer span").animate({ width: '48px' }, 5000, function() {
        $(this).css("width", "0");
      });

      currentIndex = (currentIndex + 1) % sliderArray.length;
    }

    setInterval(updateContent, 5000);
  }

  // ///////////////////////////////
  // Masonry
  if ($('body').hasClass('page-template-front-page')) {
    const masonryHeight = $('.masonry-txt').width();

    $('.masonry-matches').height(masonryHeight + 32)
    $('.masonry-4x3').height(masonryHeight + 32)
    $('.masonry-5x6').height(masonryHeight * 2 + 32 + 50)
  }

  // ///////////////////////////////
  // FAQ Accordion
  $(".faq--title").click(function(e) {
    e.preventDefault();
    const $this = $(this).closest(".container--faq-item");

    if (!$this.hasClass("container--faq-item__active")) {
      // $(".faq--content").slideUp(400);
      $(".faq--content").slideUp("fast");
      $(".container--faq-item").removeClass("container--faq-item__active");
    }

    $(this).siblings(".faq--content").slideToggle("slow");
    $this.toggleClass("container--faq-item__active");

  });

  // ///////////////////////////////
  // News Slider
  $('.home-news--wrapper').owlCarousel({
    // autoplay: true,
    autoplay: false,
    center: false,
    loop: true,
    nav: false,
    slideBy: 1,
    margin: 16,
    // padding : 16,
    singleItem: false,
    itemsScaleUp: true,
    mouseDrag: true,
    // https://owlcarousel2.github.io/OwlCarousel2/demos/responsive.html
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
        loop: true
      },
      576: {
        items: 2,
        nav: false,
        loop: true
      },
      991: {
        items: 3,
        nav: false,
        loop: true
      }
    }
  });


  // ///////////////////////////////
  // Matches Single Item
  if ($('body').hasClass('single-match')) {
    // Radial Charts

    function createCharts() {
      const items = ['.rp--item-top-left', '.rp--item-top-right', '.rp--item-bot-left', '.rp--item-bot-right'];

      items.forEach(item => {
        const dPercentT = $(`${item} .rp--item-graph-top`).data('percent');
        const dPercentB = $(`${item} .rp--item-graph-bot`).data('percent');
        const backgroundColor = $(`${item} .rp--item-heading`).css('background-color');

        const optionsT = {
          series: [dPercentT],
          chart: {
            height: 140,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '60%',
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  offsetY: 8,
                  offsetX: 8,
                  fontSize: '24px',
                  fontWeight: '400',
                  fontFamily: '"Bebas Neue", sans-serif',
                }
              }
            },
          },
          colors: [backgroundColor],
        };

        const radChartT = new ApexCharts(document.querySelector(`${item} .rp--item-graph-top`), optionsT);
        radChartT.render();

        const optionsB = {
          series: [dPercentB],
          chart: {
            height: 150,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '60%',
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  offsetY: 8,
                  offsetX: 8,
                  fontSize: '24px',
                  fontWeight: '400',
                  fontFamily: '"Bebas Neue", sans-serif',
                }
              }
            },
          },
          colors: [backgroundColor],
        };

        const radChartB = new ApexCharts(document.querySelector(`${item} .rp--item-graph-bot`), optionsB);
        radChartB.render();
      });
    }

    createCharts();

  }

  // ///////////////////////////////
  // Matches Page
  $('.matches-item--row-details').click(function() {
    const $parent = $( this ).closest( '.matches-item' );

    if ($parent.hasClass('matches-item__active')) {
      $parent.removeClass('matches-item__active');
      $('.matches-item').not($parent).removeClass('matches-item__inactive');
    } else {
      $('.matches-item').removeClass('matches-item__active matches-item__inactive');
      $parent.addClass('matches-item__active');
      $('.matches-item').not($parent).addClass('matches-item__inactive');
    }
  });

  $('.mir-title').click(function() {
    // $('.matches-subitem--row').removeClass('matches-subitem--row__active');
    $(this).closest('.matches-subitem--row').toggleClass('matches-subitem--row__active');
  });

  // ///////////////////////////////
  //


});


console.log('All Scripts Loaded');
